import Snippet from '../../components/Snippet/Snippet'
import { alignment, color, responsiveTxt, staticTxt } from '../../assets/code-snippets/text/snip'

const Text = () => {
    return <div className='row'>
        <div className='col md-I sticky order-last menu-column'>
            <div className="side-menu">
                <p className="text md bold danger">`POKE-CSS`</p>
                <p className="text xs">on this page</p>
                <ul className="primary-list">
                    <li><a href="#alignment">-Alignment-</a></li>
                    <li><a href="#static-size">-Static Size-</a></li>
                    <li><a href="#responsive-size">-Responsive Size-</a></li>
                    <li><a href="#color">-Text color-</a></li>
                </ul>
            </div>
        </div>
        <div className='col md-V content-column'>

            {/* INTRO */}
            <div className="container fluid py-2" id="intro">

                <div className="container fluid">
                    <p className="text xl"><a href="#intro" className="link">&#128279;</a> Text style in POKE-CSS </p>
                    <div className="spacer sm"></div>
                    <p className="text md">Classes available for any other tag elements:</p>
                    <div className="container xl">

                        <div className="table" padding="2" cell-spacing="3" cell-border="1" table-striped="true">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Tag Element</th>
                                        <th>Class</th>
                                        <th>Description</th>
                                        <th>Responsiveness</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><code>h, p, span, div, etc</code></td>
                                        <td><code>.text.xxs, .text.xs, .text.sm, .text.md, .text.lg, .text.xl,
                                                    .text.xxl, .text.xxxl</code></td>
                                        <td>Sets the font size</td>
                                        <td>No</td>
                                    </tr>
                                    <tr>
                                        <td><code>h, p, span, div, etc</code></td>
                                        <td><code>.text.responsive.xxs, .text.responsive.xs .text.responsive.sm,
                                        .text.responsive.md, .text.responsive.lg, .text.responsive.xl,
                                                    .text.responsive.xxl, .text.responsive.xxxl</code>
                                        </td>
                                        <td>Sets the font size</td>
                                        <td>Yes</td>
                                    </tr>
                                    <tr>
                                        <td><code>h, p, span, div, etc</code></td>
                                        <td><code>.text.dark, .text.light, .text.success, .text.danger,
                                        .text.warning, .text.info, .text.primary,
                                                    .text.secondary</code>
                                        </td>
                                        <td colSpan="2">Changes the font color</td>
                                    </tr>
                                    <tr>
                                        <td><code>h, p, span, div, etc</code></td>
                                        <td><code>.text.italic, .text.bold, .text.lighter, .text.uppercase,
                                        .text.lowercase, .text.capitalize, .text.underline,
                                                    .word-wrap</code>
                                        </td>
                                        <td colSpan="2">Changes the font style</td>
                                    </tr>
                                    <tr>
                                        <td><code>h, p, span, div, etc</code></td>
                                        <td><code>.text.right, .text.left, .text.center, .text.justify</code>
                                        </td>
                                        <td colSpan="2">Changes the text alignment</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>


                <div className="spacer md"></div>
                <p className="text md">A simple example:</p>

                <div className="row align-items-center">
                    <div className="col md-III">

                        <div className="container md">
                            <Snippet code='<p class="text lg">poke-text</p>' language='html' />
                        </div>

                    </div>
                    <div className="col md-III">
                        <div className="container sm">
                            <p className="text lg">poke-text</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* INTRO ENDS HERE */}

            {/* ALIGNMENT */}
            <div className="container fluid py-2" id="alignment">

                <div className="container fluid">
                    <p className="text xl"><a href="#alignment" className="link">&#128279;</a> Text alignment </p>
                </div>

                <div className="spacer md"></div>

                <div className="row align-items-center">
                    <div className="col md-III">

                        <div className="container md">
                            <Snippet code={alignment} language='html' />
                        </div>

                    </div>
                    <div className="col md-III">

                        <div className="container sm">
                            <p className="text lg left">text</p>
                            <p className="text lg center">text</p>
                            <p className="text lg right">text</p>
                        </div>

                    </div>
                </div>
            </div>
            {/* ALIGNMENT ENDS HERE */}

            {/* STATIC SIZES */}
            <div className="container fluid py-2" id="static-size">
                <div className="container fluid">
                    <p className="text xl"><a href="#static-size" className="link">&#128279;</a> Text static size </p>
                </div>
                <div className="spacer md"></div>
                <div className="row align-items-center">
                    <div className="col md-III">
                        <div className="container md">
                            <Snippet code={staticTxt} language='html' />
                        </div>
                    </div>
                    <div className="col md-III">
                        <div className="container sm">
                            <p className="m-0 text xxs">text</p>
                            <p className="m-0 text xs">text</p>
                            <p className="m-0 text sm">text</p>
                            <p className="m-0 text md">text</p>
                            <p className="m-0 text lg">text</p>
                            <p className="m-0 text xl">text</p>
                            <p className="m-0 text xxl">text</p>
                            <p className="m-0 text xxxl">text</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* STATIC SIZES ENDS HERE */}

            {/* RESPONSIVE SIZES */}
            <div className="container fluid py-2" id="responsive-size">
                <div className="container fluid">
                    <p className="text xl"><a href="#responsive-size" className="link">&#128279;</a> Text <span className="bold">responsive</span> sizes </p>
                </div>
                <div className="spacer md"> </div>
                <div className="row align-items-center">
                    <div className="col md-III">
                        <div className="container md">
                            <Snippet code={responsiveTxt} language='html' />
                        </div>
                    </div>
                    <div className="col md-III">
                        <div className="container sm">
                            <p className="m-0 text responsive xl">text</p>
                            <p className="m-0 text responsive xxl">text</p>
                            <p className="m-0 text responsive xxxl">text</p>
                            <p className="m-0 text responsive xxxxl">text</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* RESPONSIVE SIZES ENDS HERE */}

            {/* COLOR */}
            <div className="container fluid py-2" id="color">
                <div className="container fluid">
                    <p className="text xl"><a href="#color" className="link">&#128279;</a> Text color </p>
                </div>
                <div className="spacer md"></div>

                <div className="row align-items-center">
                    <div className="col md-III">
                        <div className="container md">
                            <Snippet code={color} language='html' />
                        </div>
                    </div>
                    <div className="col md-III">
                        <div className="container sm">
                            <p className="text md dark">dark</p>
                            <div style={{ backgroundColor: '#000' }}>
                                <p className="text md light">light</p>
                            </div>
                            <p className="text md success">success</p>
                            <p className="text md danger">danger</p>
                            <p className="text md info">info</p>
                            <p className="text md primary">primary</p>
                            <p className="text md warning">warning</p>
                            <p className="text md secondary">secondary</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* COLOR ENDS HERE */}

        </div>
    </div >
}

export default Text